import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_SSH_SECURITY_INFOS = '/ssh-infos';

export const SET_SSH_SECURITY_INFOS_LOADING = 'SET_SSH_SECURITY_INFOS_LOADING';
export const GET_SSH_SECURITY_INFO = 'GET_SSH_SECURITY_INFO';
export const GET_SSH_SECURITY_INFO_FULFILLED = 'GET_SSH_SECURITY_INFO_FULFILLED';
export const GET_SSH_SECURITY_INFOS = 'GET_SSH_SECURITY_INFOS';
export const GET_SSH_SECURITY_INFOS_FULFILLED = 'GET_SSH_SECURITY_INFOS_FULFILLED';
export const GET_SSH_SECURITY_INFOS_REJECTED = 'GET_SSH_SECURITY_INFOS_REJECTED';
export const GET_SSH_SECURITY_INFOS_PENDING = 'GET_SSH_SECURITY_INFOS_PENDING';
export const GET_SSH_SECURITY_INFOS_LIST = 'GET_SSH_SECURITY_INFOS_LIST';
export const GET_SSH_SECURITY_INFOS_LIST_PENDING = 'GET_SSH_SECURITY_INFOS_LIST_PENDING';
export const GET_SSH_SECURITY_INFOS_LIST_FULFILLED = 'GET_SSH_SECURITY_INFOS_LIST_FULFILLED';
export const GO_TO_SSH_SECURITY_INFOS_CREATE = 'GO_TO_SSH_SECURITY_INFOS_CREATE';
export const GO_TO_SSH_SECURITY_INFOS_EDIT = 'GO_TO_SSH_SECURITY_INFOS_EDIT';
export const GO_TO_SSH_SECURITY_INFOS_VIEW = 'GO_TO_SSH_SECURITY_INFOS_VIEW';
export const GO_TO_SSH_SECURITY_INFOS_LIST = 'GO_TO_SSH_SECURITY_INFOS_LIST';
export const CREATE_SSH_SECURITY_INFOS = 'CREATE_SSH_SECURITY_INFOS';
export const CREATE_SSH_SECURITY_INFOS_PENDING = 'CREATE_SSH_SECURITY_INFOS_PENDING';
export const CREATE_SSH_SECURITY_INFOS_FULFILLED = 'CREATE_SSH_SECURITY_INFOS_FULFILLED';
export const CREATE_SSH_SECURITY_INFOS_REJECTED = 'CREATE_SSH_SECURITY_INFOS_REJECTED';
export const UPDATE_SSH_SECURITY_INFOS = 'UPDATE_SSH_SECURITY_INFOS';
export const UPDATE_SSH_SECURITY_INFOS_FULFILLED = 'UPDATE_SSH_SECURITY_INFOS_FULFILLED';
export const UPDATE_SSH_SECURITY_INFOS_REJECTED = 'UPDATE_SSH_SECURITY_INFOS_REJECTED';
export const DELETE_SSH_SECURITY_INFOS = 'DELETE_SSH_SECURITY_INFOS';
export const DELETE_SSH_SECURITY_INFOS_FULFILLED = 'DELETE_SSH_SECURITY_INFOS_FULFILLED';
export const DELETE_SSH_SECURITY_INFOS_REJECTED = 'DELETE_SSH_SECURITY_INFOS_REJECTED';
export const SELECT_SSH_SECURITY_INFOS = 'SELECT_SSH_SECURITY_INFOS';

export enum SshSecurityInfoPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}
export enum SshSecurityInfoActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}
export interface SshSecurityInfo {
  id: string
  SS8ID: string
  SSHTYPE: 'CLIENT' | 'SERVER'
  AUTHTYPE: 'PASSWORD' | 'SSHKEYS'
  USERNAME: string
  PASSWORD: string
  PRIVKEYFILENAME: string
  PASSPHRASE: string
  PUBKEYFILENAME: string
  SSHDIR: string
  HOSTKEYTYPE: 'RSA' | 'DSA' | 'ECDSA' | 'ED25519',
  keysConfig?: string
}

export interface SshSecurityInfoState {
  entities: SshSecurityInfo[]
  selected: SshSecurityInfo[],
  single: SshSecurityInfo | null
  createdId: string | null
  ui: SshSecurityInfoUIState
}

export interface SshSecurityInfoUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface SetSshSecurityInfoLoadingAction extends AnyAction {
  type: typeof SET_SSH_SECURITY_INFOS_LOADING
  payload: { isLoading: boolean }
}

export interface GetSshSecurityInfoAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFO
  payload: AxiosPromise<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfoFulfilledAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFO_FULFILLED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfosAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS
  payload: AxiosPromise<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfosFulfilledAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS_FULFILLED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfoRejectedAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS_REJECTED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfoListAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS_LIST
  payload: AxiosPromise<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfoListPendingAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS_LIST_PENDING
  payload: null
}

export interface GetSshSecurityInfoListFulfilledAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface GetSshSecurityInfoPendingAction extends AnyAction {
  type: typeof GET_SSH_SECURITY_INFOS_PENDING
  payload: null
}

export interface GoToSshSecurityInfoListAction extends AnyAction {
  type: typeof GO_TO_SSH_SECURITY_INFOS_LIST
}
export interface GoToSshSecurityInfoCreateAction extends AnyAction {
  type: typeof GO_TO_SSH_SECURITY_INFOS_CREATE
}

export interface GoToSshSecurityInfoEditAction extends AnyAction {
  type: typeof GO_TO_SSH_SECURITY_INFOS_EDIT
}

export interface GoToSshSecurityInfoViewAction extends AnyAction {
  type: typeof GO_TO_SSH_SECURITY_INFOS_VIEW
}

export interface CreateSshSecurityInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateSshSecurityInfoAction extends AnyAction {
  type: typeof CREATE_SSH_SECURITY_INFOS
  payload: AxiosPromise<ServerResponse<SshSecurityInfo>>
}

export interface CreateSshSecurityInfoPendingAction extends AnyAction {
  type: typeof CREATE_SSH_SECURITY_INFOS_PENDING
  payload: null
}

export interface CreateSshSecurityInfoFulfilledAction extends AnyAction {
  type: typeof CREATE_SSH_SECURITY_INFOS_FULFILLED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface CreateSshSecurityInfoRejectedAction extends AnyAction {
  type: typeof CREATE_SSH_SECURITY_INFOS_REJECTED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface UpdateSshSecurityInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateSshSecurityInfoAction extends AnyAction {
  type: typeof UPDATE_SSH_SECURITY_INFOS
  payload: AxiosPromise<ServerResponse<SshSecurityInfo>>
}

export interface UpdateSshSecurityInfoFulfilledAction extends AnyAction {
  type: typeof UPDATE_SSH_SECURITY_INFOS_FULFILLED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface UpdateSshSecurityInfoRejectedAction extends AnyAction {
  type: typeof UPDATE_SSH_SECURITY_INFOS_REJECTED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface DeleteSshSecurityInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteSshSecurityInfoAction extends AnyAction {
  type: typeof DELETE_SSH_SECURITY_INFOS
  payload: AxiosPromise<ServerResponse<SshSecurityInfo>>
}

export interface DeleteSshSecurityInfoFulfilledAction extends AnyAction {
  type: typeof DELETE_SSH_SECURITY_INFOS_FULFILLED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface DeleteSshSecurityInfoRejectedAction extends AnyAction {
  type: typeof DELETE_SSH_SECURITY_INFOS_REJECTED
  payload: AxiosResponse<ServerResponse<SshSecurityInfo>>
}

export interface SelectSshSecurityInfoAction extends AnyAction{
  type: typeof SELECT_SSH_SECURITY_INFOS
  payload: SshSecurityInfo[]
}

export type SshSecurityInfoActionTypes =
  SetSshSecurityInfoLoadingAction |
  GetSshSecurityInfoAction |
  GetSshSecurityInfoFulfilledAction |
  GetSshSecurityInfosAction |
  GetSshSecurityInfoPendingAction |
  GetSshSecurityInfosFulfilledAction |
  GetSshSecurityInfoRejectedAction |
  GetSshSecurityInfoListAction |
  GetSshSecurityInfoListPendingAction |
  GetSshSecurityInfoListFulfilledAction |
  GoToSshSecurityInfoListAction |
  GoToSshSecurityInfoCreateAction |
  GoToSshSecurityInfoEditAction |
  GoToSshSecurityInfoViewAction |
  CreateSshSecurityInfoAction |
  CreateSshSecurityInfoPendingAction |
  CreateSshSecurityInfoFulfilledAction |
  CreateSshSecurityInfoRejectedAction |
  UpdateSshSecurityInfoAction |
  UpdateSshSecurityInfoFulfilledAction |
  UpdateSshSecurityInfoRejectedAction |
  DeleteSshSecurityInfoAction |
  DeleteSshSecurityInfoFulfilledAction |
  DeleteSshSecurityInfoRejectedAction |
  SelectSshSecurityInfoAction;
